import styled from 'styled-components'
import { MD } from '../../utils/screenSizes'

export const Container = styled.div`
  width: 100%;
  max-width: 1216px;
  margin: 0 auto;

  padding: 0px 38px;

  @media (max-width: ${MD}) {
    margin-bottom: 104px;

    h2 {
      text-align: center;

      span {
        font-size: 30px;
        line-height: 33px;
      }
    }
  }
`
